export const COPY_ISIN_MODAL_LOADING_STATE_TEST_ID = "copy-isin-modal-loading-state";
